import React from 'react'
import PersonalBanking from "../PersonalBanking/PersonalBanking"

const BankHolidays = () => {

    const downloadAnnualReportPDF = () => {
        window.open("pdf/Public-Holiday-2024.pdf");
    };

    return (
        <div>
            <section style={{ paddingTop: "53px" }}>
                <img
                    className="flex justify-text-center items-text-center mx-auto pt-5 my_bg img-fluid"
                    src="Images/2.jpg"
                    style={{ height: "400px", width: "100%" }}
                    alt="First slide"
                />
            </section>

            <div class="container-fluid">
                <div class="row  pt-4">
                    <div class="col-sm-3 col-md-3 col-lg-3">

                        <PersonalBanking />

                    </div>
                    <div class="col-sm-9 col-md-6 col-lg-8">
                        <h2 className='pt-3 text-center'>Bank Holidays</h2>
                          <p className='text-center'>the Government of Maharashtra hereby declares the following days as Public Holidays in the State
of Maharashtra during the calendar year 2024  </p>

                        {/* <section class="clear  pt-2">
                            
                            <table class="table table-bordered table-striped" width="73%" align="text-center" cellpadding="0" cellspacing="5">
                                <tbody><tr>
                                    <td class="font-bold text-center ">Sr. No.</td>
                                    <td class="font-bold text-center">Date</td>
                                    <td class="font-bold text-center">Holidays</td>
                                </tr>
                                    <tr>
                                        <td class="tblifsc text-center">1</td>
                                        <td class="tblifsc text-center">26-Jan-2022</td>
                                        <td class="tblifsc1">Republic Day</td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">2</td>
                                        <td class="tblifsc text-center">1-Mar-2022</td>
                                        <td class="tblifsc1">Mahashivratri </td>
                                    </tr>
                                    <tr>
                                        <td class="tblifsc text-center">3</td>
                                        <td class="tblifsc text-center">18-Mar-2022</td>
                                        <td class="tblifsc1">Holi (Second Day)</td>
                                    </tr>
                                    <tr>
                                        <td class="tblifsc text-center">4</td>
                                        <td class="tblifsc text-center">14-Apr-2022</td>
                                        <td class="tblifsc1">Mahavir Jayanti</td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">5</td>
                                        <td class="tblifsc text-center">14-Apr-2022</td>
                                        <td class="tblifsc1">Dr.Babasaheb Ambedkar Jayanti </td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">6</td>
                                        <td class="tblifsc text-center">15-Apr-2022</td>
                                        <td class="tblifsc1">Good Friday</td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">7</td>
                                        <td class="tblifsc text-center">3-May-2022</td>
                                        <td class="tblifsc1">Ramzan-Id(Id-Ul-Fitr) (Shawal-1)</td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">8</td>
                                        <td class="tblifsc text-center">16-May-2022</td>
                                        <td class="tblifsc1">Buddha Pournima</td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">9</td>
                                        <td class="tblifsc text-center">9-Aug-2022</td>
                                        <td class="tblifsc1">Moharum</td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">10</td>
                                        <td class="tblifsc text-center">15-Aug-2022</td>
                                        <td class="tblifsc1"> Independence Day </td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">11</td>
                                        <td class="tblifsc text-center">16-Aug-2022</td>
                                        <td class="tblifsc1">Parsi New Year (Shahenshahi) </td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">12</td>
                                        <td class="tblifsc text-center">31-Aug-2022</td>
                                        <td class="tblifsc1">Ganesh Chaturthi</td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">13</td>
                                        <td class="tblifsc text-center">5-Oct-2022</td>
                                        <td class="tblifsc1">Dasara </td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">14</td>
                                        <td class="tblifsc text-center">24-Oct-2022</td>
                                        <td class="tblifsc1">Diwali Amavasya (LaxmiPuJan)</td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">15</td>
                                        <td class="tblifsc text-center">26-Oct-2022</td>
                                        <td class="tblifsc1">Diwali (Bali Pratipada</td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">16</td>
                                        <td class="tblifsc text-center">8-Nov-2022</td>
                                        <td class="tblifsc1">Guru Nanak Jayanti</td>
                                    </tr>

                                    <tr>
                                        <td colspan="3" class="font-bold text-center tblifsc"><div>Holidays on Saturday and Sunday</div></td>
                                    </tr>
                                    <tr>
                                        <td class="tblifsc text-center">1</td>
                                        <td class="tblifsc text-center">19-Feb-2022</td>
                                        <td align="right" class="tblifsc"><div align="left"> Chhatrapati Shivaji Maharaj Jayanti </div></td>
                                    </tr>
                                    <tr>
                                        <td class="tblifsc text-center">2</td>
                                        <td class="tblifsc text-center">2-Apr-2022</td>
                                        <td align="right" class="tblifsc"><div align="left">Gudhi Padwa</div></td>
                                    </tr>
                                    <tr>
                                        <td class="tblifsc text-center">3</td>
                                        <td class="tblifsc text-center">10-Apr-2022</td>
                                        <td class="tblifsc"><div align="left">Ram Navami</div></td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">4</td>
                                        <td class="tblifsc text-center">1-May-2022</td>
                                        <td class="tblifsc"><div align="left">Maharashtra Din</div></td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">5</td>
                                        <td class="tblifsc text-center">10-July-2022</td>
                                        <td class="tblifsc"><div align="left">Bakri ID (Id-Uz-Zuha)</div></td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">6</td>
                                        <td class="tblifsc text-center">2-Oct-2022</td>
                                        <td class="tblifsc"><div align="left"> Mahatma Gandhi Jayanti </div></td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">7</td>
                                        <td class="tblifsc text-center">9-Oct-2022</td>
                                        <td class="tblifsc"><div align="left">Id-E-Milad </div></td>
                                    </tr>

                                    <tr>
                                        <td class="tblifsc text-center">8</td>
                                        <td class="tblifsc text-center">25-Dec-2022</td>
                                        <td class="tblifsc"><div align="left">Christmas</div></td>
                                    </tr>

                                    <tr>
                                        <td colspan="3" class="font-bold text-center tblifsc"><div>Year End Closing</div></td>
                                    </tr>
                                    <tr>
                                        <td class="tblifsc text-center">1</td>
                                        <td class="tblifsc text-center">1-Apr-2022</td>
                                        <td align="right" class="tblifsc"><div align="left">Year End Closing</div></td>
                                    </tr>

                                </tbody></table>
                        </section> */}

                        <section id="contact" class="contact section-bg mx-40">
                            <div class="row">
                                <div class="  pb-3 px-5">
                                    <div class="info-box space-y-3 border-2 border-blue-400 dark:border-blue-300 rounded-xl">
                                        <h3>Download PDF to see all holiday   </h3>
                                        <h1 className="my_h1 px-2">
                                            <button  onClick={downloadAnnualReportPDF}
                                                href="tel:02347-276438"
                                                className="p-1 pl-5 pr-5 bg-transparent border-1 border-blue-700  text-blue-700 text-sm rounded-lg hover:bg-blue-900  focus:border-4 focus:border-blue-900"
                                            >
                                                download pdf
                                            </button>
                                        </h1>
                                    </div>
                                </div>




                            </div>
                        </section>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default BankHolidays
